module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "disabled": _vm.disabled,
      "data-track": _vm.track
    }
  }, [_c('div', {
    class: _vm.classes,
    style: ({
      backgroundColor: _vm.bgcolor,
      color: _vm.color
    }),
    on: {
      "click": _vm.bindOriginSubmit
    }
  }, [_c('span', [_vm._v("¥" + _vm._s(_vm.price))]), _vm._v("\n    立即问医生\n    "), (_vm.priceInfo && _vm.priceInfo.freeCount !== '0') ? _c('p', {
    staticClass: "new-free"
  }, [_vm._v("本次免费 剩余" + _vm._s(_vm.priceInfo.freeCount) + "次")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "new-vip-btn",
    on: {
      "click": _vm.bindVipSubmit
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.vipOpenText) + _vm._s(_vm.otherPrice))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-767e6b52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewBtn.vue
// module id = 605
// module chunks = 1